import { Component, Inject } from '@angular/core';
import { ZoningCodeAttributesPopupComponent } from '../zoning-code-attributes-popup.component';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ZoningCodeAttributeService } from 'src/app/core/services/zoning-code-attribute.service';
import { IAttributePopupParams } from 'src/app/interfaces/attribute-popup-params.interface';
import { UntypedFormBuilder } from '@angular/forms';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CalibrationUsesLabelModel } from 'src/app/models/calibrations/calibration-uses-label.model';
import IGridicsUseTag = ZoneIQCalibration.IGridicsUseTag;
import { SyncService, ZoningCodeService } from 'src/app/core/services';

type CalibrationUsesLabelPopupData = IAttributePopupParams & {
    calibrationEntity?: CalibrationUsesLabelModel;
};

@Component({
    standalone: false,
    selector: 'app-calibration-uses-label-attributes-popup',
    templateUrl: './calibration-uses-label-attributes-popup.component.html',
    styleUrl: '../attributes-popup.component.scss'
})
export class CalibrationUsesLabelAttributesPopupComponent extends ZoningCodeAttributesPopupComponent {
    readonly gridicsUseTags$: Observable<IGridicsUseTag[]> = this.zoningCodeService.zoningCodes.pipe(
        map(() => this.zoningCodeService.gridicsUseTags)
    );
    gridicsUseId: number | null = null;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: CalibrationUsesLabelPopupData,
        protected readonly attributeService: ZoningCodeAttributeService,
        protected readonly formBuilder: UntypedFormBuilder,
        public dialogRef: MatDialogRef<CalibrationUsesLabelAttributesPopupComponent>,
        private readonly zoningCodeService: ZoningCodeService,
        public readonly syncService: SyncService
    ) {
        super(data, attributeService, formBuilder, dialogRef);
    }

    get label(): CalibrationUsesLabelModel {
        return this.data?.calibrationEntity;
    }

    ngOnInit() {
        super.ngOnInit();
        this.gridicsUseId = this.label?.GridicsUseTagId ?? null;
    }

    handleGridicsUseTagIdManualChange(label: CalibrationUsesLabelModel) {
        label.markManuallyChangedProperty('GridicsUseTagId');
    }

    handleGridicsUseTagIdValueChange(label: CalibrationUsesLabelModel) {
        if (label.getIsOriginalState('GridicsUseTagId')) {
            return;
        }
        this.syncService.triggerChangeDetection();
    }

    override async save() {
        if (this.label && this.gridicsUseId !== this.label.GridicsUseTagId) {
            this.label.GridicsUseTagId = this.gridicsUseId;
            this.handleGridicsUseTagIdManualChange(this.label);
            this.handleGridicsUseTagIdValueChange(this.label);
        }

        await super.save();
    }

    onCancel() {
        this.dialogRef.close();
    }
}
